import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GroupsPage } from '../../features/B2a/groups-page';

const search = z.object({
  tab: z.enum(['assigned', 'unassigned', 'test']).optional().catch(undefined),
  /** group just joined by invite link (highlighted in the unassigned tab) */
  new: z.string().optional().catch(undefined),
  /** D-150: only the groups of this number */
  channel: z.string().optional().catch(undefined),
});

/** #/groups — WhatsApp groups (assigned / unassigned / test), sync, join by invite link, assign to a client. Lane B2a. */
export const Route = createFileRoute('/_app/groups')({
  validateSearch: search,
  component: Groups,
});

function Groups() {
  const { tab, new: newId, channel } = Route.useSearch();
  return <GroupsPage tab={tab ?? 'assigned'} newId={newId} channel={channel} />;
}
